export interface HeroSlide {
  id: string;
  mediaId: string;
  title: string;
  typeLabel: string;
  tags: string;
  description: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'h1',
    mediaId: '3',
    title: '长安十二辰',
    typeLabel: '古装 · 历史 · 悬疑',
    tags: '年度期待 · 国风美学',
    description:
      '一夜之间，京城命案频发。不良人与大理寺少卿必须在十二个时辰内联手破局，在灯火长安之下揭开一场动摇朝局的阴谋。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20ancient%20chinese%20palace%20street%20at%20night%20filled%20with%20warm%20red%20lanterns%20and%20silk%20banners%20epic%20historical%20atmosphere%20deep%20shadows%20for%20text%20overlay%20no%20text%20high%20detail&width=1600&height=900&seq=hero-01&orientation=landscape',
  },
  {
    id: 'h2',
    mediaId: '1',
    title: '雾都黎明',
    typeLabel: '悬疑 · 犯罪 · 剧情',
    tags: '高分神剧 · 高能反转',
    description:
      '迷雾笼罩的旧城区连环案，一位老刑警与年轻搭档在真相与谎言之间步步逼近，每一次靠近都让旧日的秘密更加清晰。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%20old%20city%20at%20dawn%20with%20muted%20crimson%20light%20and%20a%20lone%20detective%20silhouette%20moody%20atmosphere%20dark%20corners%20for%20text%20overlay%20no%20text%20high%20detail&width=1600&height=900&seq=hero-02&orientation=landscape',
  },
  {
    id: 'h3',
    mediaId: '4',
    title: '星轨之外',
    typeLabel: '科幻 · 冒险',
    tags: '硬科幻 · 视觉奇观',
    description:
      '一次失联的深空任务，让一名宇航员在星轨之外面对人类文明最艰难的抉择。当记忆与记录出现偏差，真相究竟在哪一边。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20lone%20astronaut%20facing%20a%20giant%20ringed%20planet%20deep%20orange%20nebula%20and%20warm%20dust%20dramatic%20scale%20dark%20frame%20for%20text%20overlay%20no%20text%20high%20detail&width=1600&height=900&seq=hero-03&orientation=landscape',
  },
  {
    id: 'h4',
    mediaId: '5',
    title: '首尔夜行',
    typeLabel: '都市 · 爱情 · 剧情',
    tags: '氛围感 · 都市治愈',
    description:
      '一个写不出下一本书的作家，和一家通宵花店的老板娘，在雨夜的城市里相遇，也慢慢学会了与自己的过去和解。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20neon%20lit%20city%20street%20at%20night%20with%20two%20silhouettes%20under%20one%20umbrella%20warm%20pink%20and%20amber%20reflections%20romantic%20mood%20no%20text%20high%20detail&width=1600&height=900&seq=hero-04&orientation=landscape',
  },
  {
    id: 'h5',
    mediaId: '11',
    title: '山海食堂',
    typeLabel: '治愈 · 美食 · 剧情',
    tags: '深夜食堂 · 烟火气',
    description:
      '巷子深处一家只在黄昏开门的小食堂，用一道道家常菜，接住每一个疲惫的归人，也接住那些说不出口的心事。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20cozy%20little%20tavern%20with%20steaming%20dishes%20and%20warm%20lantern%20light%20rustic%20wooden%20interior%20comforting%20evening%20atmosphere%20dark%20frame%20for%20text%20no%20text%20high%20detail&width=1600&height=900&seq=hero-05&orientation=landscape',
  },
];

export interface CategoryEntry {
  key: string;
  title: string;
  description: string;
  icon: string;
  link: string;
  accent: string;
}

export const categoryEntries: CategoryEntry[] = [
  {
    key: 'tv',
    title: '电视剧',
    description: '国产剧、韩剧、美剧、英剧、日剧，海量剧集随心筛选',
    icon: 'ri-tv-2-line',
    link: '/category?type=tv',
    accent: 'primary',
  },
  {
    key: 'movie',
    title: '电影',
    description: '院线大片、文艺佳作、类型电影，一网打尽好片',
    icon: 'ri-film-line',
    link: '/category?type=movie',
    accent: 'accent',
  },
  {
    key: 'topic',
    title: '热门专题',
    description: '高分神剧、年度期待、治愈片单，编辑精选合集',
    icon: 'ri-fire-line',
    link: '/category?tag=高分神剧',
    accent: 'secondary',
  },
];

export interface AboutStat {
  value: string;
  label: string;
}

export const aboutStats: AboutStat[] = [
  { value: '12,000+', label: '收录影视作品' },
  { value: '3,600+', label: '演员资料' },
  { value: '每日更新', label: '影视资讯' },
  { value: '全站免费', label: '浏览与检索' },
];